import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { BlockNavigationService } from './block-navigation.service';
import { ModalPopupService } from '@app/main/cablepro/modal-popup.service';

/**
 * This Class used to show confirmation popup when navigation is blocked
 * to apply this gard need to add following line in each respective route
 *  {
        path: '/route',
        canDeactivate: [BlockNavigationGuard],
        ...
    }
 *
 */
@Injectable({
  providedIn: 'root'
})
export class BlockNavigationGuard implements CanDeactivate<unknown> {

  constructor(private blockNavigationService: BlockNavigationService,
    private modalPopupService: ModalPopupService
  ) {}

  async canDeactivate(): Promise<boolean> {
    if (!this.blockNavigationService.isBlocked()) {
      return true;
    }

    return await (new Promise((res) => {

        this.modalPopupService.confirm(
            this.blockNavigationService.getTitle(),
            this.blockNavigationService.getMessage(),
            (value: boolean) => {
                res(!value)
            },
            'fa fa-warning text-danger',
            'Stay on This Page',
            'btn-secondary',
            'Leave Anyway',
            'btn-danger', false, false, false, undefined
        );

    }))
  }
}
